import React from 'react';
import { GlobeIcon, ShoppingBasketIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const reasons = [{
  icon: ShoppingBasketIcon,
  title: 'Alimentos disponibles',
  text: 'Verduras, proteínas y carbohidratos que conseguís en toda LATAM y España.'
}, {
  icon: GlobeIcon,
  title: 'Estructuras universales',
  text: 'Los principios y protocolos funcionan aunque tu supermercado sea distinto.'
}];
export function WhyGlobal() {
  return;
}